import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Link from '@precis-digital/kurama/Link';
import Typography from '@precis-digital/kurama/Typography';
import { useTheme } from '@precis-digital/kurama/utils';
import ThemedImage from 'shared/components/Themed/Image';
import starWandIcon from 'public/assets/images/star_wand.svg';
import { UnStyledRetainDefaultQueryLink } from 'shared/components/Router';
import { APP_ROUTES } from 'shared/routes';
import { useTranslation } from 'shared/translations';
const NoReport = () => {
  const $ = _c(28);
  const theme = useTheme();
  const {
    t
  } = useTranslation("home");
  let t0;
  if ($[0] !== theme) {
    t0 = theme.spacing(3);
    $[0] = theme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== theme) {
    t1 = theme.spacing(5);
    $[2] = theme;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ThemedImage src={starWandIcon.src} alt="star wand icon" width={335} height={169} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("noReportTitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Typography variant="h5">{t3}</Typography>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("noReportPrompt1");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("noReportPrompt2");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <UnStyledRetainDefaultQueryLink href={APP_ROUTES.reportingSolutions.createConfigPage}><Link variant="body3" href="#">{t6}</Link>{" "}</UnStyledRetainDefaultQueryLink>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("noReportPrompt3");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t7 || $[19] !== t8) {
    t9 = <Typography variant="body3">{t5}{t7}{t8}</Typography>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t4 || $[22] !== t9) {
    t10 = <Grid container={true} direction="column" alignItems="center" maxWidth={400} textAlign="center">{t4}{t9}</Grid>;
    $[21] = t4;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t0 || $[25] !== t1 || $[26] !== t10) {
    t11 = <Grid container={true} direction="column" alignItems="center" justifyContent="center" paddingTop={t0} gap={t1}>{t2}{t10}</Grid>;
    $[24] = t0;
    $[25] = t1;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default NoReport;